import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import Icon from 'components/Icon'
import { Button, Kbd } from '@arnsbogroup/react-voicearchive'
import Modal from 'components/Modal'


const DialogOverlay = ({ children, ...props }) => (
  <Modal className="p-0" childClassName="p-0">
    <div className="" {...props}>
      { children }
    </div>
  </Modal>
)

const DialogWrapper = ({ children, ...props }) => (
  <div className="" {...props}>
    { children }
  </div>
)

const DialogTitle = ({ children, ...props }) => (
  <div className="w-full px-4 py-2 font-medium shadow" {...props}>
    { children }
  </div>
)

const DialogBody = ({ children, className = 'p-4', ...props }) => (
  <div className={className} {...props}>
    { children }
  </div>
)

export class Announcement extends Component {
  state = {
    open: false,
    announcement: undefined
  }

  onClose = () => {
    this.setState({ open: false })
  }

  onAck = () => {
    fetch('/system/announcement', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.announcement)
    }).then(() => {
      this.setState({ open: false })
    });
  }

  componentWillMount() {
    fetch('/system/announcement')
      .then((response) => response.json())
      .then(({data}) => {
        if (data && data.body) {
          this.setState({ announcement: data, open: true })
        }
      });
  }

  render() {
    const { body, onAcknowledge } = this.props
    const { open, announcement } = this.state

    if (!open) {
      return null
    }

    return (
      <DialogOverlay>
        <DialogWrapper>
          <DialogTitle>
            <div className="flex justify-between">
              <span>{ announcement.title }</span>
              <Icon icon="times" className="text-primary hover:text-primary-darker cursor-pointer" onClick={this.onClose} />
            </div>
          </DialogTitle>
          <DialogBody className="p-4">
            <div className="markdown-body">
              <ReactMarkdown
                children={announcement.body}
                components={{
                  img: ({ node, ...props }) => <img className="border border-gray-400 shadow-sm my-8 max-w-full" {...props} />,
                  ul: ({ node, ...props }) => <ul className="list-disc" {...props } />,
                  kbd: ({ node, ...props }) => <Kbd {...props} />,
                }}
              />
            </div>
          </DialogBody>
          <div className="p-4 flex justify-between text-primary font-medium">
            <div>
                { announcement.url &&
                  <a href={announcement.url} target="_blank">
                    <Button variant="outline">
                      Details
                    </Button>
                  </a>
                }
            </div>
            <Button onClick={this.onAck}>
              Acknowledge
            </Button>
          </div>
        </DialogWrapper>
      </DialogOverlay>
    )
  }
}

export default Announcement
